import * as React from 'react';
import { Input, Label, makeStyles, useId } from '@fluentui/react-components';
import { flexColumn, flexRow, formInputInlineStyle, formStyle } from "../styles/GlobalStyles";
import { IDatabaseRecord } from '../dto/IDatabaseRecord';
import { formatDate } from './DateText';

const useStyles = makeStyles({
    footerItem: {
        ...formInputInlineStyle,
        margin: "auto"
    },
    form: formStyle,
    flexRow: flexRow,
    flexColumn: flexColumn,
    footer: {
        ...flexRow,
        backgroundColor: "#333",
        flexWrap: "wrap",
        padding: "10px",
        borderRadius: "5px",
        alignItems: "center",
        justifyContent: "center"
    }
});

export interface RecordsBaseDataProps
{
    record: IDatabaseRecord;
}

export const RecordBaseData: React.FC<RecordsBaseDataProps> = ({ record }) =>
{
    const styles = useStyles();

    const modifiedOnInputId = useId("modifiedOn");
    const modifiedByInputId = useId("modifiedBy");
    const createdOnInputId = useId("createdOn");
    const createdByInputId = useId("createdBy");    

    return (
        <div className={styles.footer}>
            <div className={styles.footerItem}>
                <Label htmlFor={modifiedOnInputId} size="medium">
                    Modified On
                </Label>
                <Input id={modifiedOnInputId} type="text" value={formatDate(record.modifiedOn)} style={{ minWidth: "0px" }} disabled />
            </div>
            <div className={styles.footerItem}>
                <Label htmlFor={modifiedByInputId} size="medium">
                    Modified By
                </Label>
                <Input id={modifiedByInputId} type="text" value={record.modifiedBy?.name ?? ""} style={{ minWidth: "0px" }} disabled />
            </div>
        
            <div className={styles.footerItem}>
                <Label htmlFor={createdOnInputId} size="medium">
                    Created On
                </Label>
                <Input id={createdOnInputId} type="text" value={formatDate(record.createdOn)} style={{ minWidth: "0px" }} disabled />
            </div>
            <div className={styles.footerItem}>
                <Label htmlFor={createdByInputId} size="medium">
                    Created By
                </Label>
                <Input id={createdByInputId} type="text" value={record.createdBy?.name ?? ""} style={{ minWidth: "0px" }} disabled />
            </div>
        </div>
        )
}